






























































































import Vue from "vue";

import { Splitpanes, Pane } from "splitpanes";
import "splitpanes/dist/splitpanes.css";

import AppPage from "@/components/AppPage.vue";
import DeviceTree from "@/components/DeviceTree/index.vue";
import { LocalStorageManager } from "@/plugins/LocalStorageManager";

export default Vue.extend({
    components: {
        AppPage,
        DeviceTree,
        Splitpanes,
        Pane,
    },
    props: {
        deviceTreeTitle: {
            type: String,
            default: null,
        },
        hideActions: {
            required: false,
        },
        value: Array,
        selectionType: {
            type: String,
            default: "leaf",
        },
        preselectRoot: {
            type: Boolean,
            default: false,
        },
        organizations: Array,
    },
    data() {
        return {
            deviceTreeSidebarSize: 25,
            deviceTreeCollapsed: false,
        };
    },
    watch: {
        deviceTreeSidebarSize() {
            LocalStorageManager.Write("device_tree_sidebar_size", this.deviceTreeSidebarSize);
        },
        deviceTreeCollapsed() {
            LocalStorageManager.Write("device_tree_collapsed", this.deviceTreeCollapsed);
        },
    },
    computed: {
        selectedDevices: {
            get() {
                // if (this.value && this.value.length) return this.value;
                // else return null;
                return this.value;
            },
            set(newVal) {
                // if (newVal && (newVal as any).length) this.$emit("input", newVal);
                // else this.$emit("input", null);
                this.$emit("input", newVal);
            },
        },
    },
    mounted() {
        const device_tree_collapsed = LocalStorageManager.Read("device_tree_collapsed");
        if (device_tree_collapsed != null) this.deviceTreeCollapsed = device_tree_collapsed == "true";

        const device_tree_sidebar_size = LocalStorageManager.Read("device_tree_sidebar_size");
        if (device_tree_sidebar_size != null) this.deviceTreeSidebarSize = device_tree_sidebar_size;
    },
});
